import { render, staticRenderFns } from "./UpsellEditorDialog.vue?vue&type=template&id=767458a4&"
import script from "./UpsellEditorDialog.vue?vue&type=script&lang=js&"
export * from "./UpsellEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpsellEditorDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports